module.exports = __webpack_public_path__ + "static/img/zongxin2.a5e3473f.png";